import React from 'react'
import './Header.css'
import {Avatar} from "@material-ui/core"
import AccessTimeIcon from "@material-ui/icons/AccessTime"
import SearchIcon from '@material-ui/icons/Search';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {useStateValue} from './StateProvider'
import clsx from 'clsx'
import {auth} from '../Firebase'
import { actionTypes } from './Reducer'

function Header() {
    const [{user}]=useStateValue()
    const [menuIsOpen,setMenuIsOpen]=React.useState(false)
    const [state,dispatch]=useStateValue()

    const handleOpen=() =>{ 
        setMenuIsOpen(!menuIsOpen)
        console.log(menuIsOpen)
    }
    const logOut = () => {
        auth.signOut().then(() =>{
            console.log('signedout successfully')
            dispatch({
                type : actionTypes.SET_USER,
                user : null
            })
        }
            
        ).catch(err => console.log(err))
        
    }
    return (
        <div className="Header">
           <div className="header__left">
                {/* avatar for logged in user */}
                <Avatar className="header__avatar"
                        alt={user?.displayName}
                        src={user?.photoURL}
                        onClick={handleOpen} />
                
                    <ul className={clsx({'header__menuOpened':menuIsOpen,
                                      'header__menuClosed':!menuIsOpen})}
                        onClick={logOut}>
                        <li> Logout</li>                       
                    </ul>
                       
                {/* time icon */}
                <AccessTimeIcon />

           </div>  
           <div className="header__search">
               {/* search icon */}
               <SearchIcon />
               {/* input */}
                <input placeholder="Search Amine slack clone" type="text"/>
           </div>  
           <div className="header__right">
               {/* help icon */}
               <HelpOutlineIcon />
           </div>
        </div>
    )
}

export default Header
